import { Title } from "../../model"

export function getTitle(titles: Title[], id: number): Title|null {
	return titles.find(t => t.id === id) || null
}


// WEBPACK FOOTER //
// ./src/domain/sfp/title-domain.ts